import * as React from "react";

import { UitkCard } from "uitk-react-cards";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkSpacing } from "uitk-react-spacing";

import { DefaultCardContents } from "./DefaultCardContents";

import { PackageCardProps } from "components/flexComponents/Packages/typings";

export const PackageCardMobile = ({ packageItem, index, language }: PackageCardProps) => (
  <UitkSpacing margin={{ blockstart: "three" }}>
    <UitkCard>
      <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
        <UitkImage src={packageItem.hotelImageUrl} alt={packageItem.hotelName} placeholderImage />
      </UitkFigure>
      <UitkLayoutPosition type="relative" cloneElement>
        <DefaultCardContents packageItem={packageItem} index={index} language={language} overImage />
      </UitkLayoutPosition>
    </UitkCard>
  </UitkSpacing>
);
